import React, { useState } from "react";
import { analytics } from "../../analytics";

// Where a web visitor can see and change their analytics choice after the banner is gone.
// Linked from the privacy policy. Signed-in shop customers can also change it in their Profile.
export default function AnalyticsSettings() {
  const [choice, setChoice] = useState(() => analytics.getConsent());

  const choose = (granted) => {
    analytics.setConsent(granted);
    setChoice(granted ? "granted" : "denied");
  };

  const status =
    choice === "granted"
      ? "Analytics is on."
      : choice === "denied"
        ? "Analytics is off."
        : "You have not chosen yet. Analytics is off until you accept.";

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl shadow-blue-900/10 border border-slate-100 p-6 text-slate-700 text-sm leading-relaxed">
        <h1 className="text-xl font-black text-slate-900 mb-2">Analytics settings</h1>
        <p className="mb-4">
          With your permission we use Google Analytics to understand how Ota Life is used and to improve it. No advertising
          ID and no ads. You can change your choice here at any time. See our{" "}
          <a href="/privacy-policy" className="text-blue-600 underline">
            Privacy Policy
          </a>
          .
        </p>
        <p className="font-semibold text-slate-900 mb-4" role="status">
          {status}
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => choose(true)}
            className="px-4 py-2 rounded-lg border border-blue-600 text-blue-700 font-semibold"
          >
            Turn on
          </button>
          <button
            type="button"
            onClick={() => choose(false)}
            className="px-4 py-2 rounded-lg border border-blue-600 text-blue-700 font-semibold"
          >
            Turn off
          </button>
        </div>
      </div>
    </div>
  );
}
